//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import VueMarkdown from "vue-markdown";
export default {
  components: {
    VueMarkdown,
  },
  props: {
    image: {
      type: String,
      default: null,
    },
    chatIcon: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: null,
    },
    textShadow: {
      type: String,
      default: "0px 3px 19px black",
    },
  },
};
